import queryString from 'query-string';

import { useHistory, useLocation, useParams } from 'react-router-dom';
import useRoutes from './useRoutes';

export default function useRouter() {
  const history = useHistory();
  const location = useLocation();
  const { getRouteName, path } = useRoutes();
  const params = useParams<Record<string, string>>();
  const routeName = getRouteName(location.pathname, params);
  const queryParams = queryString.parse(window.location.search);

  function setQueryParams(newQueryParams: Record<string, string>) {
    const allQueryParams = {
      ...queryParams,
      ...newQueryParams,
    };

    // Remove null queryParams
    Object.keys(allQueryParams).forEach(
      (key) =>
        (allQueryParams[key] === null || allQueryParams[key] === '') &&
        delete allQueryParams[key]
    );

    window.history.pushState(
      '',
      '',
      `${location.pathname}?${queryString.stringify(allQueryParams)}`
    );
  }

  function setParams(newParams: Record<string, string>) {
    const allParams: Record<string, string> = {};

    Object.keys(params).forEach((key) => {
      if (newParams[key]) {
        allParams[key] = newParams[key];
      } else {
        allParams[key] = params[key];
      }
    });
    history.push(path(routeName, allParams));
  }

  return {
    ...{
      history,
      location,
    },
    ...{
      routeName,
      queryParams,
      setQueryParams,
      params,
      setParams,
    },
  };
}
